import React from 'react';

const BlazeAuthContext = React.createContext();
const BlazeAuthContextProvider = BlazeAuthContext.Provider;
const BlazeAuthContextConsumer = BlazeAuthContext.Consumer;

export { BlazeAuthContext, BlazeAuthContextProvider, BlazeAuthContextConsumer };
